import Box from 'components/ui/box';
import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { useEffect, useState } from 'react';
import { TbMailFast } from 'react-icons/tb';
import { FiChevronRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { getMembrosEquipeGestor, getPlayerInfo } from 'services/dashboard.service';
import { navLinks } from 'types/navigation';
import MegaPhone from 'assets/img/megaphone-icon.svg';
import { MdContentPasteSearch } from 'react-icons/md';

export default function Nav() {
  const { user, userInfo } = useAuth();
  const [isGestor, setIsGestor] = useState(false);
  const [hasTeam, setHasTeam] = useState(false);

  const URLs: any = [
    {
      title: 'Página Inicial',
      url: '/',
    },
    {
      title: 'Meus Reconhecimentos',
      url: '/extrato',
    },
    {
      title: 'Galeria',
      url: '/galeria',
    },
    hasTeam && {
      title: 'Minha Equipe',
      url: '/minha-equipe',
    },
    {
      title: 'Regulamento',
      url: '/regulamento',
    },
    {
      title: 'Dúvidas Frequentes',
      url: '/ajuda',
    },
  ].filter(Boolean);

  useEffect(() => {
    async function loadTeam() {
      if (
        userInfo &&
        (userInfo.tipo_ro === 'GERENCIAL' ||
          userInfo.funcao_localizacao === 3001 ||
          userInfo.funcao_localizacao === 3002 ||
          userInfo.funcao_localizacao === 3003)
      ) {
        const data = await getMembrosEquipeGestor(userInfo._id);
        // const _usersNeedingApproval = await getUsersNeedingApproval();
        // setUsersNeedingApproval(_usersNeedingApproval);

        if (data?.result?.length) setHasTeam(true);
      }
    }

    if (!!userInfo && !!user) {
      setIsGestor(userInfo.tipo_ro === 'GERENCIAL' || userInfo.funcao === 'DIRETOR');
      loadTeam();
    }
  }, [user, userInfo]);

  return (
    <div id="nav">
      <ul className="space-y-6">
        {URLs.map((item: any) => (
          <li key={item.url}>
            <Link to={item.url} className="flex items-center justify-between text-base uppercase font-normal text-[#C2D2FF]">
              {item.title} <FiChevronRight className="text-xl" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
